import * as React from "react"
import {Container} from "semantic-ui-react"

export function Article(props: { children: React.ReactNode }) {
  return <Container text as="article" children={props.children}/>
}



// WEBPACK FOOTER //
// ./src/components/About.tsx